module.exports = __webpack_public_path__ + "img/charity_2.983e5fba.png";